module.exports = __webpack_public_path__ + "static/media/img195.4c82b36b.jpg";